import {
  FOOD_PREORDER_EVENT_LIST,
  FOOD_PREORDER_EVENT_LIST_SUCCESS,
  FOOD_PREORDER_EVENT_LIST_FAIL,
  FOOD_PREORDER_EVENT_SEARCH,
  FOOD_PREORDER_EVENT_SEARCH_SUCCESS,
  FOOD_PREORDER_EVENT_SEARCH_FAIL,
  FOOD_PREORDER_EVENT_DATA,
  FOOD_PREORDER_EVENT_DATA_SUCCESS,
  FOOD_PREORDER_EVENT_DATA_FAIL,
  FOOD_PREORDER_EVENT_CREATE,
  FOOD_PREORDER_EVENT_CREATE_SUCCESS,
  FOOD_PREORDER_EVENT_CREATE_FAIL,
  FOOD_PREORDER_EVENT_UPDATE,
  FOOD_PREORDER_EVENT_UPDATE_SUCCESS,
  FOOD_PREORDER_EVENT_UPDATE_FAIL,
  FOOD_PREORDER_EVENT_DELETE,
  FOOD_PREORDER_EVENT_DELETE_SUCCESS,
  FOOD_PREORDER_EVENT_DELETE_FAIL,
  FOOD_PREORDER_EVENT_GUEST_LIST,
  FOOD_PREORDER_EVENT_GUEST_LIST_SUCCESS,
  FOOD_PREORDER_EVENT_GUEST_LIST_FAIL,
  FOOD_PREORDER_EVENT_GUEST_SEARCH,
  FOOD_PREORDER_EVENT_GUEST_SEARCH_SUCCESS,
  FOOD_PREORDER_EVENT_GUEST_SEARCH_FAIL,
  FOOD_PREORDER_EVENT_GUEST_DATA,
  FOOD_PREORDER_EVENT_GUEST_DATA_SUCCESS,
  FOOD_PREORDER_EVENT_GUEST_DATA_FAIL,
  FOOD_PREORDER_EVENT_GUEST_INVITE,
  FOOD_PREORDER_EVENT_GUEST_INVITE_SUCCESS,
  FOOD_PREORDER_EVENT_GUEST_INVITE_FAIL,
  FOOD_PREORDER_EVENT_GUEST_DELETE,
  FOOD_PREORDER_EVENT_GUEST_DELETE_SUCCESS,
  FOOD_PREORDER_EVENT_GUEST_DELETE_FAIL,
  FOOD_MENU_STATUS_LIST,
  FOOD_MENU_STATUS_LIST_SUCCESS,
  FOOD_MENU_STATUS_LIST_FAIL,
  FOOD_MENU_STATUS_DATA,
  FOOD_MENU_STATUS_DATA_SUCCESS,
  FOOD_MENU_STATUS_DATA_FAIL,
  FOOD_MENU_STATUS_CREATE,
  FOOD_MENU_STATUS_CREATE_SUCCESS,
  FOOD_MENU_STATUS_CREATE_FAIL,
  FOOD_MENU_STATUS_UPDATE,
  FOOD_MENU_STATUS_UPDATE_SUCCESS,
  FOOD_MENU_STATUS_UPDATE_FAIL,
  FOOD_MENU_STATUS_DELETE,
  FOOD_MENU_STATUS_DELETE_SUCCESS,
  FOOD_MENU_STATUS_DELETE_FAIL,
  FOOD_MENU_LIST,
  FOOD_MENU_LIST_SUCCESS,
  FOOD_MENU_LIST_FAIL,
  FOOD_MENU_DATA,
  FOOD_MENU_DATA_SUCCESS,
  FOOD_MENU_DATA_FAIL,
  FOOD_MENU_CREATE,
  FOOD_MENU_CREATE_SUCCESS,
  FOOD_MENU_CREATE_FAIL,
  FOOD_MENU_UPDATE,
  FOOD_MENU_UPDATE_SUCCESS,
  FOOD_MENU_UPDATE_FAIL,
  FOOD_MENU_DELETE,
  FOOD_MENU_DELETE_SUCCESS,
  FOOD_MENU_DELETE_FAIL,
  FOOD_MENU_CATEGORY_LIST,
  FOOD_MENU_CATEGORY_LIST_SUCCESS,
  FOOD_MENU_CATEGORY_LIST_FAIL,
  FOOD_MENU_CATEGORY_DATA,
  FOOD_MENU_CATEGORY_DATA_SUCCESS,
  FOOD_MENU_CATEGORY_DATA_FAIL,
  FOOD_MENU_CATEGORY_CREATE,
  FOOD_MENU_CATEGORY_CREATE_SUCCESS,
  FOOD_MENU_CATEGORY_CREATE_FAIL,
  FOOD_MENU_CATEGORY_UPDATE,
  FOOD_MENU_CATEGORY_UPDATE_SUCCESS,
  FOOD_MENU_CATEGORY_UPDATE_FAIL,
  FOOD_MENU_CATEGORY_DELETE,
  FOOD_MENU_CATEGORY_DELETE_SUCCESS,
  FOOD_MENU_CATEGORY_DELETE_FAIL,
  FOOD_MENU_ITEM_LIST,
  FOOD_MENU_ITEM_LIST_SUCCESS,
  FOOD_MENU_ITEM_LIST_FAIL,
  FOOD_MENU_ITEM_DATA,
  FOOD_MENU_ITEM_DATA_SUCCESS,
  FOOD_MENU_ITEM_DATA_FAIL,
  FOOD_MENU_ITEM_CREATE,
  FOOD_MENU_ITEM_CREATE_SUCCESS,
  FOOD_MENU_ITEM_CREATE_FAIL,
  FOOD_MENU_ITEM_UPDATE,
  FOOD_MENU_ITEM_UPDATE_SUCCESS,
  FOOD_MENU_ITEM_UPDATE_FAIL,
  FOOD_MENU_ITEM_DELETE,
  FOOD_MENU_ITEM_DELETE_SUCCESS,
  FOOD_MENU_ITEM_DELETE_FAIL,
  FOOD_PREORDER_EVENT_STATUS_LIST,
  FOOD_PREORDER_EVENT_STATUS_LIST_SUCCESS,
  FOOD_PREORDER_EVENT_STATUS_LIST_FAIL,
  FOOD_PREORDER_EVENT_STATUS_DATA,
  FOOD_PREORDER_EVENT_STATUS_DATA_SUCCESS,
  FOOD_PREORDER_EVENT_STATUS_DATA_FAIL,
  FOOD_PREORDER_EVENT_STATUS_CREATE,
  FOOD_PREORDER_EVENT_STATUS_CREATE_SUCCESS,
  FOOD_PREORDER_EVENT_STATUS_CREATE_FAIL,
  FOOD_PREORDER_EVENT_STATUS_UPDATE,
  FOOD_PREORDER_EVENT_STATUS_UPDATE_SUCCESS,
  FOOD_PREORDER_EVENT_STATUS_UPDATE_FAIL,
  FOOD_PREORDER_EVENT_STATUS_DELETE,
  FOOD_PREORDER_EVENT_STATUS_DELETE_SUCCESS,
  FOOD_PREORDER_EVENT_STATUS_DELETE_FAIL,
  FOOD_PREORDER_EVENT_TYPE_LIST,
  FOOD_PREORDER_EVENT_TYPE_LIST_SUCCESS,
  FOOD_PREORDER_EVENT_TYPE_LIST_FAIL,
  FOOD_PREORDER_EVENT_TYPE_DATA,
  FOOD_PREORDER_EVENT_TYPE_DATA_SUCCESS,
  FOOD_PREORDER_EVENT_TYPE_DATA_FAIL,
  FOOD_PREORDER_EVENT_TYPE_CREATE,
  FOOD_PREORDER_EVENT_TYPE_CREATE_SUCCESS,
  FOOD_PREORDER_EVENT_TYPE_CREATE_FAIL,
  FOOD_PREORDER_EVENT_TYPE_UPDATE,
  FOOD_PREORDER_EVENT_TYPE_UPDATE_SUCCESS,
  FOOD_PREORDER_EVENT_TYPE_UPDATE_FAIL,
  FOOD_PREORDER_EVENT_TYPE_DELETE,
  FOOD_PREORDER_EVENT_TYPE_DELETE_SUCCESS,
  FOOD_PREORDER_EVENT_TYPE_DELETE_FAIL,
  FOOD_MENU_TYPE_LIST,
  FOOD_MENU_TYPE_LIST_SUCCESS,
  FOOD_MENU_TYPE_LIST_FAIL,
  FOOD_MENU_TYPE_DATA,
  FOOD_MENU_TYPE_DATA_SUCCESS,
  FOOD_MENU_TYPE_DATA_FAIL,
  FOOD_MENU_TYPE_CREATE,
  FOOD_MENU_TYPE_CREATE_SUCCESS,
  FOOD_MENU_TYPE_CREATE_FAIL,
  FOOD_MENU_TYPE_UPDATE,
  FOOD_MENU_TYPE_UPDATE_SUCCESS,
  FOOD_MENU_TYPE_UPDATE_FAIL,
  FOOD_MENU_TYPE_DELETE,
  FOOD_MENU_TYPE_DELETE_SUCCESS,
  FOOD_MENU_TYPE_DELETE_FAIL,
  FOOD_PREORDER_SITE_LOCATION_LIST,
  FOOD_PREORDER_SITE_LOCATION_LIST_SUCCESS,
  FOOD_PREORDER_SITE_LOCATION_LIST_FAIL,
  FOOD_PREORDER_SITE_LOCATION_DATA,
  FOOD_PREORDER_SITE_LOCATION_DATA_SUCCESS,
  FOOD_PREORDER_SITE_LOCATION_DATA_FAIL,
  FOOD_PREORDER_SITE_LOCATION_CREATE,
  FOOD_PREORDER_SITE_LOCATION_CREATE_SUCCESS,
  FOOD_PREORDER_SITE_LOCATION_CREATE_FAIL,
  FOOD_PREORDER_SITE_LOCATION_UPDATE,
  FOOD_PREORDER_SITE_LOCATION_UPDATE_SUCCESS,
  FOOD_PREORDER_SITE_LOCATION_UPDATE_FAIL,
  FOOD_PREORDER_SITE_LOCATION_DELETE,
  FOOD_PREORDER_SITE_LOCATION_DELETE_SUCCESS,
  FOOD_PREORDER_SITE_LOCATION_DELETE_FAIL,
  FOOD_PREORDER_EVENT_GUEST_TO_FOOD_MENU_ITEM_CREATE,
  FOOD_PREORDER_EVENT_GUEST_TO_FOOD_MENU_ITEM_CREATE_SUCCESS,
  FOOD_PREORDER_EVENT_GUEST_TO_FOOD_MENU_ITEM_CREATE_FAIL,
  FOOD_PREORDER_EVENT_GUEST_ACCEPT,
  FOOD_PREORDER_EVENT_GUEST_ACCEPT_SUCCESS,
  FOOD_PREORDER_EVENT_GUEST_ACCEPT_FAIL,
  FOOD_PREORDER_EVENT_GUEST_DECLINE,
  FOOD_PREORDER_EVENT_GUEST_DECLINE_SUCCESS,
  FOOD_PREORDER_EVENT_GUEST_DECLINE_FAIL,
  FOOD_MENU_SEARCH,
  FOOD_MENU_SEARCH_SUCCESS,
  FOOD_MENU_SEARCH_FAIL,
  FOOD_PREORDER_EVENT_EMAIL_ORGANISER_EVENT_READY,
  FOOD_PREORDER_EVENT_EMAIL_ORGANISER_EVENT_READY_SUCCESS,
  FOOD_PREORDER_EVENT_EMAIL_ORGANISER_EVENT_READY_FAIL,
  FOOD_PREORDER_EVENT_GUEST_INVITE_RESEND,
  FOOD_PREORDER_EVENT_GUEST_INVITE_RESEND_SUCCESS,
  FOOD_PREORDER_EVENT_GUEST_INVITE_RESEND_FAIL,
  FOOD_PREORDER_EVENT_PDF_GUEST_LIST_CONFIRMED,
  FOOD_PREORDER_EVENT_PDF_GUEST_LIST_CONFIRMED_SUCCESS,
  FOOD_PREORDER_EVENT_PDF_GUEST_LIST_CONFIRMED_FAIL,
  FOOD_PREORDER_EVENT_PDF_KITCHEN_MEAL_PLAN,
  FOOD_PREORDER_EVENT_PDF_KITCHEN_MEAL_PLAN_SUCCESS,
  FOOD_PREORDER_EVENT_PDF_KITCHEN_MEAL_PLAN_FAIL,
  FOOD_PREORDER_EVENT_PDF_TABLE_TENT_CARDS,
  FOOD_PREORDER_EVENT_PDF_TABLE_TENT_CARDS_SUCCESS,
  FOOD_PREORDER_EVENT_PDF_TABLE_TENT_CARDS_FAIL,
  FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST,
  FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_SUCCESS,
  FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_FAIL,
  FOOD_PREORDER_EVENT_COMMUNICATION_LIST,
  FOOD_PREORDER_EVENT_COMMUNICATION_LIST_SUCCESS,
  FOOD_PREORDER_EVENT_COMMUNICATION_LIST_FAIL,
  FOOD_PREORDER_EVENT_ATTACHMENT_SEARCH,
  FOOD_PREORDER_EVENT_ATTACHMENT_SEARCH_SUCCESS,
  FOOD_PREORDER_EVENT_ATTACHMENT_SEARCH_FAIL,
  FOOD_PREORDER_EVENT_ATTACHMENT_DELETE,
  FOOD_PREORDER_EVENT_ATTACHMENT_DELETE_SUCCESS,
  FOOD_PREORDER_EVENT_ATTACHMENT_DELETE_FAIL,
  FOOD_PREORDER_EVENT_SMS_ORGANISER_EVENT_READY,
  FOOD_PREORDER_EVENT_SMS_ORGANISER_EVENT_READY_SUCCESS,
  FOOD_PREORDER_EVENT_SMS_ORGANISER_EVENT_READY_FAIL,
  FOOD_MENU_ITEM_SEARCH,
  FOOD_MENU_ITEM_SEARCH_SUCCESS,
  FOOD_MENU_ITEM_SEARCH_FAIL,
  FOOD_PREORDER_EVENT_PDF_FRONT_OF_HOUSE_MEAL_PLAN,
  FOOD_PREORDER_EVENT_PDF_FRONT_OF_HOUSE_MEAL_PLAN_SUCCESS,
  FOOD_PREORDER_EVENT_PDF_FRONT_OF_HOUSE_MEAL_PLAN_FAIL,
  FOOD_PREORDER_EVENT_GUEST_PAYMENT_LIST,
  FOOD_PREORDER_EVENT_GUEST_PAYMENT_LIST_SUCCESS,
  FOOD_PREORDER_EVENT_GUEST_PAYMENT_LIST_FAIL,
  FOOD_PREORDER_EVENT_GUEST_PAYMENT_SEARCH,
  FOOD_PREORDER_EVENT_GUEST_PAYMENT_SEARCH_SUCCESS,
  FOOD_PREORDER_EVENT_GUEST_PAYMENT_SEARCH_FAIL,
  FOOD_PREORDER_EVENT_GROUP_LIST,
  FOOD_PREORDER_EVENT_GROUP_LIST_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_LIST_FAIL,
  FOOD_PREORDER_EVENT_GROUP_DATA,
  FOOD_PREORDER_EVENT_GROUP_DATA_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_DATA_FAIL,
  FOOD_PREORDER_EVENT_GROUP_CREATE,
  FOOD_PREORDER_EVENT_GROUP_CREATE_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_CREATE_FAIL,
  FOOD_PREORDER_EVENT_GROUP_UPDATE,
  FOOD_PREORDER_EVENT_GROUP_UPDATE_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_UPDATE_FAIL,
  FOOD_PREORDER_EVENT_GROUP_DELETE,
  FOOD_PREORDER_EVENT_GROUP_DELETE_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_DELETE_FAIL,
  FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_DATA,
  FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_DATA_SUCCESS,
  FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_DATA_FAIL,
  FOOD_PREORDER_EVENT_GROUP_PDF_KITCHEN_MEAL_PLAN,
  FOOD_PREORDER_EVENT_GROUP_PDF_KITCHEN_MEAL_PLAN_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_PDF_KITCHEN_MEAL_PLAN_FAIL,
  FOOD_PREORDER_EVENT_GROUP_PDF_FRONT_OF_HOUSE_MEAL_PLAN,
  FOOD_PREORDER_EVENT_GROUP_PDF_FRONT_OF_HOUSE_MEAL_PLAN_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_PDF_FRONT_OF_HOUSE_MEAL_PLAN_FAIL,
  FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_TENT_CARDS,
  FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_TENT_CARDS_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_TENT_CARDS_FAIL,
  FOOD_PREORDER_EVENT_GROUP_PDF_GUEST_LIST_CONFIRMED,
  FOOD_PREORDER_EVENT_GROUP_PDF_GUEST_LIST_CONFIRMED_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_PDF_GUEST_LIST_CONFIRMED_FAIL,
  FOOD_PREORDER_EVENT_GROUP_CSV_KITCHEN_MEAL_PLAN,
  FOOD_PREORDER_EVENT_GROUP_CSV_KITCHEN_MEAL_PLAN_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_CSV_KITCHEN_MEAL_PLAN_FAIL,
  FOOD_PREORDER_EVENT_GROUP_CSV_FRONT_OF_HOUSE_MEAL_PLAN,
  FOOD_PREORDER_EVENT_GROUP_CSV_FRONT_OF_HOUSE_MEAL_PLAN_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_CSV_FRONT_OF_HOUSE_MEAL_PLAN_FAIL,
  FOOD_PREORDER_EVENT_GROUP_CSV_GUEST_LIST_CONFIRMED,
  FOOD_PREORDER_EVENT_GROUP_CSV_GUEST_LIST_CONFIRMED_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_CSV_GUEST_LIST_CONFIRMED_FAIL,
  FOOD_PREORDER_EVENT_GROUP_CSV_TABLE_PLAN_LIST,
  FOOD_PREORDER_EVENT_GROUP_CSV_TABLE_PLAN_LIST_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_CSV_TABLE_PLAN_LIST_FAIL,
  FOOD_PREORDER_EVENT_CSV_KITCHEN_MEAL_PLAN,
  FOOD_PREORDER_EVENT_CSV_KITCHEN_MEAL_PLAN_SUCCESS,
  FOOD_PREORDER_EVENT_CSV_KITCHEN_MEAL_PLAN_FAIL,
  FOOD_PREORDER_EVENT_CSV_FRONT_OF_HOUSE_MEAL_PLAN,
  FOOD_PREORDER_EVENT_CSV_FRONT_OF_HOUSE_MEAL_PLAN_SUCCESS,
  FOOD_PREORDER_EVENT_CSV_FRONT_OF_HOUSE_MEAL_PLAN_FAIL,
  FOOD_PREORDER_EVENT_CSV_GUEST_LIST_CONFIRMED,
  FOOD_PREORDER_EVENT_CSV_GUEST_LIST_CONFIRMED_SUCCESS,
  FOOD_PREORDER_EVENT_CSV_GUEST_LIST_CONFIRMED_FAIL,
  FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_PLAN_LIST,
  FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_PLAN_LIST_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_PLAN_LIST_FAIL,
  FOOD_PREORDER_EVENT_GROUP_CSV_DRINK_LIST_BY_TABLE,
  FOOD_PREORDER_EVENT_GROUP_CSV_DRINK_LIST_BY_TABLE_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_CSV_DRINK_LIST_BY_TABLE_FAIL,
  FOOD_PREORDER_EVENT_GROUP_PDF_DRINK_LIST_BY_TABLE,
  FOOD_PREORDER_EVENT_GROUP_PDF_DRINK_LIST_BY_TABLE_SUCCESS,
  FOOD_PREORDER_EVENT_GROUP_PDF_DRINK_LIST_BY_TABLE_FAIL,
  FOOD_PREORDER_SITE_LOCATION_SEARCH,
  FOOD_PREORDER_SITE_LOCATION_SEARCH_SUCCESS,
  FOOD_PREORDER_SITE_LOCATION_SEARCH_FAIL,
  FOOD_MENU_CLONE,
  FOOD_MENU_CLONE_SUCCESS,
  FOOD_MENU_CLONE_FAIL,
} from "./actionType";

const initialState = {
  foodPreOrderEventList: [],
  foodPreOrderEventListLoading: false,
  foodPreOrderEventListError: null,

  foodPreOrderEventSearch: [],
  foodPreOrderEventSearchLoading: false,
  foodPreOrderEventSearchError: null,

  foodPreOrderEventData: [],
  foodPreOrderEventDataLoading: false,
  foodPreOrderEventDataError: null,

  foodPreOrderEventCreate: [],
  foodPreOrderEventCreateLoading: false,
  foodPreOrderEventCreateError: null,

  foodPreOrderEventUpdate: [],
  foodPreOrderEventUpdateLoading: false,
  foodPreOrderEventUpdateError: null,

  foodPreOrderEventDelete: [],
  foodPreOrderEventDeleteLoading: false,
  foodPreOrderEventDeleteError: null,

  foodPreOrderEventGuestList: [],
  foodPreOrderEventGuestListLoading: false,
  foodPreOrderEventGuestListError: null,

  foodPreOrderEventGuestSearch: [],
  foodPreOrderEventGuestSearchLoading: false,
  foodPreOrderEventGuestSearchError: null,

  foodPreOrderEventGuestData: [],
  foodPreOrderEventGuestDataLoading: false,
  foodPreOrderEventGuestDataError: null,

  foodPreOrderEventGuestInvite: [],
  foodPreOrderEventGuestInviteLoading: false,
  foodPreOrderEventGuestInviteError: null,

  foodPreOrderEventGuestDelete: [],
  foodPreOrderEventGuestDeleteLoading: false,
  foodPreOrderEventGuestDeleteError: null,

  foodMenuStatusList: [],
  foodMenuStatusListLoading: false,
  foodMenuStatusListError: null,

  foodMenuStatusData: [],
  foodMenuStatusDataLoading: false,
  foodMenuStatusDataError: null,

  foodMenuStatusCreate: [],
  foodMenuStatusCreateLoading: false,
  foodMenuStatusCreateError: null,

  foodMenuStatusUpdate: [],
  foodMenuStatusUpdateLoading: false,
  foodMenuStatusUpdateError: null,

  foodMenuStatusDelete: [],
  foodMenuStatusDeleteLoading: false,
  foodMenuStatusDeleteError: null,

  foodMenuList: [],
  foodMenuListLoading: false,
  foodMenuListError: null,

  foodMenuData: [],
  foodMenuDataLoading: false,
  foodMenuDataError: null,

  foodMenuCreate: [],
  foodMenuCreateLoading: false,
  foodMenuCreateError: null,

  foodMenuUpdate: [],
  foodMenuUpdateLoading: false,
  foodMenuUpdateError: null,

  foodMenuDelete: [],
  foodMenuDeleteLoading: false,
  foodMenuDeleteError: null,

  foodMenuCategoryList: [],
  foodMenuCategoryListLoading: false,
  foodMenuCategoryListError: null,

  foodMenuCategoryData: [],
  foodMenuCategoryDataLoading: false,
  foodMenuCategoryDataError: null,

  foodMenuCategoryCreate: [],
  foodMenuCategoryCreateLoading: false,
  foodMenuCategoryCreateError: null,

  foodMenuCategoryUpdate: [],
  foodMenuCategoryUpdateLoading: false,
  foodMenuCategoryUpdateError: null,

  foodMenuCategoryDelete: [],
  foodMenuCategoryDeleteLoading: false,
  foodMenuCategoryDeleteError: null,

  foodMenuItemList: [],
  foodMenuItemListLoading: false,
  foodMenuItemListError: null,

  foodMenuItemData: [],
  foodMenuItemDataLoading: false,
  foodMenuItemDataError: null,

  foodMenuItemCreate: [],
  foodMenuItemCreateLoading: false,
  foodMenuItemCreateError: null,

  foodMenuItemUpdate: [],
  foodMenuItemUpdateLoading: false,
  foodMenuItemUpdateError: null,

  foodMenuItemDelete: [],
  foodMenuItemDeleteLoading: false,
  foodMenuItemDeleteError: null,

  foodPreOrderEventStatusList: [],
  foodPreOrderEventStatusListLoading: false,
  foodPreOrderEventStatusListError: null,

  foodPreOrderEventStatusData: [],
  foodPreOrderEventStatusDataLoading: false,
  foodPreOrderEventStatusDataError: null,

  foodPreOrderEventStatusCreate: [],
  foodPreOrderEventStatusCreateLoading: false,
  foodPreOrderEventStatusCreateError: null,

  foodPreOrderEventStatusUpdate: [],
  foodPreOrderEventStatusUpdateLoading: false,
  foodPreOrderEventStatusUpdateError: null,

  foodPreOrderEventStatusDelete: [],
  foodPreOrderEventStatusDeleteLoading: false,
  foodPreOrderEventStatusDeleteError: null,

  foodPreOrderEventTypeList: [],
  foodPreOrderEventTypeListLoading: false,
  foodPreOrderEventTypeListError: null,

  foodPreOrderEventTypeData: [],
  foodPreOrderEventTypeDataLoading: false,
  foodPreOrderEventTypeDataError: null,

  foodPreOrderEventTypeCreate: [],
  foodPreOrderEventTypeCreateLoading: false,
  foodPreOrderEventTypeCreateError: null,

  foodPreOrderEventTypeUpdate: [],
  foodPreOrderEventTypeUpdateLoading: false,
  foodPreOrderEventTypeUpdateError: null,

  foodPreOrderEventTypeDelete: [],
  foodPreOrderEventTypeDeleteLoading: false,
  foodPreOrderEventTypeDeleteError: null,

  foodMenuTypeList: [],
  foodMenuTypeListLoading: false,
  foodMenuTypeListError: null,

  foodMenuTypeData: [],
  foodMenuTypeDataLoading: false,
  foodMenuTypeDataError: null,

  foodMenuTypeCreate: [],
  foodMenuTypeCreateLoading: false,
  foodMenuTypeCreateError: null,

  foodMenuTypeUpdate: [],
  foodMenuTypeUpdateLoading: false,
  foodMenuTypeUpdateError: null,

  foodMenuTypeDelete: [],
  foodMenuTypeDeleteLoading: false,
  foodMenuTypeDeleteError: null,

  foodPreOrderSiteLocationList: [],
  foodPreOrderSiteLocationListLoading: false,
  foodPreOrderSiteLocationListError: null,

  foodPreOrderSiteLocationData: [],
  foodPreOrderSiteLocationDataLoading: false,
  foodPreOrderSiteLocationDataError: null,

  foodPreOrderSiteLocationCreate: [],
  foodPreOrderSiteLocationCreateLoading: false,
  foodPreOrderSiteLocationCreateError: null,

  foodPreOrderSiteLocationUpdate: [],
  foodPreOrderSiteLocationUpdateLoading: false,
  foodPreOrderSiteLocationUpdateError: null,

  foodPreOrderSiteLocationDelete: [],
  foodPreOrderSiteLocationDeleteLoading: false,
  foodPreOrderSiteLocationDeleteError: null,

  foodPreOrderEventGuestToFoodMenuItemCreate: [],
  foodPreOrderEventGuestToFoodMenuItemCreateLoading: false,
  foodPreOrderEventGuestToFoodMenuItemCreateError: null,

  foodPreOrderEventGuestAccept: [],
  foodPreOrderEventGuestAcceptLoading: false,
  foodPreOrderEventGuestAcceptError: null,

  foodPreOrderEventGuestDecline: [],
  foodPreOrderEventGuestDeclineLoading: false,
  foodPreOrderEventGuestDeclineError: null,

  foodMenuSearch: [],
  foodMenuSearchLoading: false,
  foodMenuSearchError: null,

  foodPreOrderEventEmailOrganiserEventReady: [],
  foodPreOrderEventEmailOrganiserEventReadyLoading: false,
  foodPreOrderEventEmailOrganiserEventReadyError: null,

  foodPreOrderEventGuestInviteResend: [],
  foodPreOrderEventGuestInviteResendLoading: false,
  foodPreOrderEventGuestInviteResendError: null,

  foodPreOrderEventPdfGuestListConfirmed: [],
  foodPreOrderEventPdfGuestListConfirmedLoading: false,
  foodPreOrderEventPdfGuestListConfirmedError: null,

  foodPreOrderEventPdfKitchenMealPlan: [],
  foodPreOrderEventPdfKitchenMealPlanLoading: false,
  foodPreOrderEventPdfKitchenMealPlanError: null,

  foodPreOrderEventPdfTableTentCards: [],
  foodPreOrderEventPdfTableTentCardsLoading: false,
  foodPreOrderEventPdfTableTentCardsError: null,

  foodPreOrderEventRecentActivityList: [],
  foodPreOrderEventRecentActivityListLoading: false,
  foodPreOrderEventRecentActivityListError: null,

  foodPreOrderEventCommunicationList: [],
  foodPreOrderEventCommunicationListLoading: false,
  foodPreOrderEventCommunicationListError: null,

  foodPreOrderEventAttachmentList: [],
  foodPreOrderEventAttachmentListLoading: false,
  foodPreOrderEventAttachmentListError: null,

  foodPreOrderEventAttachmentDelete: [],
  foodPreOrderEventAttachmentDeleteLoading: false,
  foodPreOrderEventAttachmentDeleteError: null,

  foodPreOrderEventSmsOrganiserEventReady: [],
  foodPreOrderEventSmsOrganiserEventReadyLoading: false,
  foodPreOrderEventSmsOrganiserEventReadyError: null,

  foodMenuItemSearch: [],
  foodMenuItemSearchLoading: false,
  foodMenuItemSearchError: null,

  foodPreOrderEventPdfFrontOfHouseMealPlan: [],
  foodPreOrderEventPdfFrontOfHouseMealPlanLoading: false,
  foodPreOrderEventPdfFrontOfHouseMealPlanError: null,

  foodPreOrderEventGuestPaymentList: [],
  foodPreOrderEventGuestPaymentListLoading: false,
  foodPreOrderEventGuestPaymentListError: null,

  foodPreOrderEventGuestPaymentSearch: [],
  foodPreOrderEventGuestPaymentSearchLoading: false,
  foodPreOrderEventGuestPaymentSearchError: null,

  foodPreOrderEventGroupList: [],
  foodPreOrderEventGroupListLoading: false,
  foodPreOrderEventGroupListError: null,

  foodPreOrderEventGroupData: [],
  foodPreOrderEventGroupDataLoading: false,
  foodPreOrderEventGroupDataError: null,

  foodPreOrderEventGroupCreate: [],
  foodPreOrderEventGroupCreateLoading: false,
  foodPreOrderEventGroupCreateError: null,

  foodPreOrderEventGroupUpdate: [],
  foodPreOrderEventGroupUpdateLoading: false,
  foodPreOrderEventGroupUpdateError: null,

  foodPreOrderEventGroupDelete: [],
  foodPreOrderEventGroupDeleteLoading: false,
  foodPreOrderEventGroupDeleteError: null,

  foodPreOrderEventRecentActivityListData: [],
  foodPreOrderEventRecentActivityListDataLoading: false,
  foodPreOrderEventRecentActivityListDataError: null,

  foodPreOrderEventGroupPdfKitchenMealPlan: [],
  foodPreOrderEventGroupPdfKitchenMealPlanLoading: false,
  foodPreOrderEventGroupPdfKitchenMealPlanError: null,

  foodPreOrderEventGroupPdfFrontOfHouseMealPlan: [],
  foodPreOrderEventGroupPdfFrontOfHouseMealPlanLoading: false,
  foodPreOrderEventGroupPdfFrontOfHouseMealPlanError: null,

  foodPreOrderEventGroupPdfTableTentCards: [],
  foodPreOrderEventGroupPdfTableTentCardsLoading: false,
  foodPreOrderEventGroupPdfTableTentCardsError: null,

  foodPreOrderEventGroupPdfGuestListConfirmed: [],
  foodPreOrderEventGroupPdfGuestListConfirmedLoading: false,
  foodPreOrderEventGroupPdfGuestListConfirmedError: null,

  foodPreOrderEventGroupPdfTablePlanList: [],
  foodPreOrderEventGroupPdfTablePlanListLoading: false,
  foodPreOrderEventGroupPdfTablePlanListError: null,

  // CSV
  foodPreOrderEventGroupCsvKitchenMealPlan: [],
  foodPreOrderEventGroupCsvKitchenMealPlanLoading: false,
  foodPreOrderEventGroupCsvKitchenMealPlanError: null,

  foodPreOrderEventGroupCsvFrontOfHouseMealPlan: [],
  foodPreOrderEventGroupCsvFrontOfHouseMealPlanLoading: false,
  foodPreOrderEventGroupCsvFrontOfHouseMealPlanError: null,

  foodPreOrderEventGroupCsvGuestListConfirmed: [],
  foodPreOrderEventGroupCsvGuestListConfirmedLoading: false,
  foodPreOrderEventGroupCsvGuestListConfirmedError: null,

  foodPreOrderEventGroupCsvTablePlanList: [],
  foodPreOrderEventGroupCsvTablePlanListLoading: false,
  foodPreOrderEventGroupCsvTablePlanListError: null,

  foodPreOrderEventCsvKitchenMealPlan: [],
  foodPreOrderEventCsvKitchenMealPlanLoading: false,
  foodPreOrderEventCsvKitchenMealPlanError: null,

  foodPreOrderEventCsvFrontOfHouseMealPlan: [],
  foodPreOrderEventCsvFrontOfHouseMealPlanLoading: false,
  foodPreOrderEventCsvFrontOfHouseMealPlanError: null,

  foodPreOrderEventCsvGuestListConfirmed: [],
  foodPreOrderEventCsvGuestListConfirmedLoading: false,
  foodPreOrderEventCsvGuestListConfirmedError: null,

  foodPreOrderEventGroupCsvDrinkListByTable: [],
  foodPreOrderEventGroupCsvDrinkListByTableLoading: false,
  foodPreOrderEventGroupCsvDrinkListByTableError: null,

  foodPreOrderEventGroupPdfDrinkListByTable: [],
  foodPreOrderEventGroupPdfDrinkListByTableLoading: false,
  foodPreOrderEventGroupPdfDrinkListByTableError: null,

  foodPreOrderSiteLocationSearch: [],
  foodPreOrderSiteLocationSearchLoading: false,
  foodPreOrderSiteLocationSearchError: null,

  foodMenuClone: [],
  foodMenuCloneLoading: false,
  foodMenuCloneError: null,
};

const FoodPreOrderEventReducer = (state = initialState, action) => {
  switch (action.type) {
    case FOOD_PREORDER_EVENT_LIST:
      return {
        ...state,
        foodPreOrderEventListLoading: true,
        foodPreOrderEventListError: null,
      };
    case FOOD_PREORDER_EVENT_LIST_SUCCESS:
      return {
        ...state,
        foodPreOrderEventList: action.payload,
        foodPreOrderEventListLoading: false,
      };
    case FOOD_PREORDER_EVENT_LIST_FAIL:
      return {
        ...state,
        foodPreOrderEventListLoading: false,
        foodPreOrderEventListError: action.payload,
      };
    case FOOD_PREORDER_EVENT_SEARCH:
      return {
        ...state,
        foodPreOrderEventSearchLoading: true,
        foodPreOrderEventSearchError: null,
      };
    case FOOD_PREORDER_EVENT_SEARCH_SUCCESS:
      return {
        ...state,
        foodPreOrderEventSearch: action.payload,
        foodPreOrderEventSearchLoading: false,
      };
    case FOOD_PREORDER_EVENT_SEARCH_FAIL:
      return {
        ...state,
        foodPreOrderEventSearchLoading: false,
        foodPreOrderEventSearchError: action.payload,
      };
    case FOOD_PREORDER_EVENT_DATA:
      return {
        ...state,
        foodPreOrderEventDataLoading: true,
        foodPreOrderEventDataError: null,
      };
    case FOOD_PREORDER_EVENT_DATA_SUCCESS:
      return {
        ...state,
        foodPreOrderEventData: action.payload,
        foodPreOrderEventDataLoading: false,
      };
    case FOOD_PREORDER_EVENT_DATA_FAIL:
      return {
        ...state,
        foodPreOrderEventDataLoading: false,
        foodPreOrderEventDataError: action.payload,
      };
    case FOOD_PREORDER_EVENT_CREATE:
      return {
        ...state,
        foodPreOrderEventCreateLoading: true,
        foodPreOrderEventCreateError: null,
      };
    case FOOD_PREORDER_EVENT_CREATE_SUCCESS:
      return {
        ...state,
        foodPreOrderEventCreate: action.payload,
        foodPreOrderEventCreateLoading: false,
      };
    case FOOD_PREORDER_EVENT_CREATE_FAIL:
      return {
        ...state,
        foodPreOrderEventCreateLoading: false,
        foodPreOrderEventCreateError: action.payload,
      };

    case FOOD_PREORDER_EVENT_UPDATE:
      return {
        ...state,
        foodPreOrderEventUpdateLoading: true,
        foodPreOrderEventUpdateError: null,
      };
    case FOOD_PREORDER_EVENT_UPDATE_SUCCESS:
      return {
        ...state,
        foodPreOrderEventUpdate: action.payload,
        foodPreOrderEventUpdateLoading: false,
      };
    case FOOD_PREORDER_EVENT_UPDATE_FAIL:
      return {
        ...state,
        foodPreOrderEventUpdateLoading: false,
        foodPreOrderEventUpdateError: action.payload,
      };

    case FOOD_PREORDER_EVENT_DELETE:
      return {
        ...state,
        foodPreOrderEventDeleteLoading: true,
        foodPreOrderEventDeleteError: null,
      };
    case FOOD_PREORDER_EVENT_DELETE_SUCCESS:
      return {
        ...state,
        foodPreOrderEventDelete: action.payload,
        foodPreOrderEventDeleteLoading: false,
      };
    case FOOD_PREORDER_EVENT_DELETE_FAIL:
      return {
        ...state,
        foodPreOrderEventDeleteLoading: false,
        foodPreOrderEventDeleteError: action.payload,
      };

    case FOOD_PREORDER_EVENT_GUEST_LIST:
      return {
        ...state,
        foodPreOrderEventGuestListLoading: true,
        foodPreOrderEventGuestListError: null,
      };
    case FOOD_PREORDER_EVENT_GUEST_LIST_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGuestList: action.payload,
        foodPreOrderEventGuestListLoading: false,
      };
    case FOOD_PREORDER_EVENT_GUEST_LIST_FAIL:
      return {
        ...state,
        foodPreOrderEventGuestListLoading: false,
        foodPreOrderEventGuestListError: action.payload,
      };

    case FOOD_PREORDER_EVENT_GUEST_SEARCH:
      return {
        ...state,
        foodPreOrderEventGuestSearchLoading: true,
        foodPreOrderEventGuestSearchError: null,
      };
    case FOOD_PREORDER_EVENT_GUEST_SEARCH_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGuestSearch: action.payload,
        foodPreOrderEventGuestSearchLoading: false,
      };
    case FOOD_PREORDER_EVENT_GUEST_SEARCH_FAIL:
      return {
        ...state,
        foodPreOrderEventGuestSearchLoading: false,
        foodPreOrderEventGuestSearchError: action.payload,
      };

    case FOOD_PREORDER_EVENT_GUEST_DATA:
      return {
        ...state,
        foodPreOrderEventGuestDataLoading: true,
        foodPreOrderEventGuestDataError: null,
      };
    case FOOD_PREORDER_EVENT_GUEST_DATA_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGuestData: action.payload,
        foodPreOrderEventGuestDataLoading: false,
      };
    case FOOD_PREORDER_EVENT_GUEST_DATA_FAIL:
      return {
        ...state,
        foodPreOrderEventGuestDataLoading: false,
        foodPreOrderEventGuestDataError: action.payload,
      };

    case FOOD_PREORDER_EVENT_GUEST_INVITE:
      return {
        ...state,
        foodPreOrderEventGuestInviteLoading: true,
        foodPreOrderEventGuestInviteError: null,
      };
    case FOOD_PREORDER_EVENT_GUEST_INVITE_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGuestInvite: action.payload,
        foodPreOrderEventGuestInviteLoading: false,
      };
    case FOOD_PREORDER_EVENT_GUEST_INVITE_FAIL:
      return {
        ...state,
        foodPreOrderEventGuestInviteLoading: false,
        foodPreOrderEventGuestInviteError: action.payload,
      };

    case FOOD_PREORDER_EVENT_GUEST_DELETE:
      return {
        ...state,
        foodPreOrderEventGuestDeleteLoading: true,
        foodPreOrderEventGuestDeleteError: null,
      };

    case FOOD_PREORDER_EVENT_GUEST_DELETE_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGuestDelete: action.payload,
        foodPreOrderEventGuestDeleteLoading: false,
      };
    case FOOD_PREORDER_EVENT_GUEST_DELETE_FAIL:
      return {
        ...state,
        foodPreOrderEventGuestDeleteLoading: false,
        foodPreOrderEventGuestDeleteError: action.payload,
      };

    case FOOD_MENU_STATUS_LIST:
      return {
        ...state,
        foodMenuStatusListLoading: true,
        foodMenuStatusListError: null,
      };
    case FOOD_MENU_STATUS_LIST_SUCCESS:
      return {
        ...state,
        foodMenuStatusList: action.payload,
        foodMenuStatusListLoading: false,
      };
    case FOOD_MENU_STATUS_LIST_FAIL:
      return {
        ...state,
        foodMenuStatusListLoading: false,
        foodMenuStatusListError: action.payload,
      };
    case FOOD_MENU_STATUS_DATA:
      return {
        ...state,
        foodMenuStatusDataLoading: true,
        foodMenuStatusDataError: null,
      };
    case FOOD_MENU_STATUS_DATA_SUCCESS:
      return {
        ...state,
        foodMenuStatusData: action.payload,
        foodMenuStatusDataLoading: false,
      };
    case FOOD_MENU_STATUS_DATA_FAIL:
      return {
        ...state,
        foodMenuStatusDataLoading: false,
        foodMenuStatusDataError: action.payload,
      };
    case FOOD_MENU_STATUS_CREATE:
      return {
        ...state,
        foodMenuStatusCreateLoading: true,
        foodMenuStatusCreateError: null,
      };
    case FOOD_MENU_STATUS_CREATE_SUCCESS:
      return {
        ...state,
        foodMenuStatusCreate: action.payload,
        foodMenuStatusCreateLoading: false,
      };
    case FOOD_MENU_STATUS_CREATE_FAIL:
      return {
        ...state,
        foodMenuStatusCreateLoading: false,
        foodMenuStatusCreateError: action.payload,
      };
    case FOOD_MENU_STATUS_UPDATE:
      return {
        ...state,
        foodMenuStatusUpdateLoading: true,
        foodMenuStatusUpdateError: null,
      };
    case FOOD_MENU_STATUS_UPDATE_SUCCESS:
      return {
        ...state,
        foodMenuStatusUpdate: action.payload,
        foodMenuStatusUpdateLoading: false,
      };
    case FOOD_MENU_STATUS_UPDATE_FAIL:
      return {
        ...state,
        foodMenuStatusUpdateLoading: false,
        foodMenuStatusUpdateError: action.payload,
      };
    case FOOD_MENU_STATUS_DELETE:
      return {
        ...state,
        foodMenuStatusDeleteLoading: true,
        foodMenuStatusDeleteError: null,
      };
    case FOOD_MENU_STATUS_DELETE_SUCCESS:
      return {
        ...state,
        foodMenuStatusDelete: action.payload,
        foodMenuStatusDeleteLoading: false,
      };
    case FOOD_MENU_STATUS_DELETE_FAIL:
      return {
        ...state,
        foodMenuStatusDeleteLoading: false,
        foodMenuStatusDeleteError: action.payload,
      };
    case FOOD_MENU_LIST:
      return {
        ...state,
        foodMenuListLoading: true,
        foodMenuListError: null,
      };
    case FOOD_MENU_LIST_SUCCESS:
      return {
        ...state,
        foodMenuList: action.payload,
        foodMenuListLoading: false,
      };
    case FOOD_MENU_LIST_FAIL:
      return {
        ...state,
        foodMenuListLoading: false,
        foodMenuListError: action.payload,
      };
    case FOOD_MENU_DATA:
      return {
        ...state,
        foodMenuDataLoading: true,
        foodMenuDataError: null,
      };
    case FOOD_MENU_DATA_SUCCESS:
      return {
        ...state,
        foodMenuData: action.payload,
        foodMenuDataLoading: false,
      };
    case FOOD_MENU_DATA_FAIL:
      return {
        ...state,
        foodMenuDataLoading: false,
        foodMenuDataError: action.payload,
      };
    case FOOD_MENU_CREATE:
      return {
        ...state,
        foodMenuCreateLoading: true,
        foodMenuCreateError: null,
      };
    case FOOD_MENU_CREATE_SUCCESS:
      return {
        ...state,
        foodMenuCreate: action.payload,
        foodMenuCreateLoading: false,
      };
    case FOOD_MENU_CREATE_FAIL:
      return {
        ...state,
        foodMenuCreateLoading: false,
        foodMenuCreateError: action.payload,
      };
    case FOOD_MENU_UPDATE:
      return {
        ...state,
        foodMenuUpdateLoading: true,
        foodMenuUpdateError: null,
      };
    case FOOD_MENU_UPDATE_SUCCESS:
      return {
        ...state,
        foodMenuUpdate: action.payload,
        foodMenuUpdateLoading: false,
      };
    case FOOD_MENU_UPDATE_FAIL:
      return {
        ...state,
        foodMenuUpdateLoading: false,
        foodMenuUpdateError: action.payload,
      };
    case FOOD_MENU_DELETE:
      return {
        ...state,
        foodMenuDeleteLoading: true,
        foodMenuDeleteError: null,
      };
    case FOOD_MENU_DELETE_SUCCESS:
      return {
        ...state,
        foodMenuDelete: action.payload,
        foodMenuDeleteLoading: false,
      };
    case FOOD_MENU_DELETE_FAIL:
      return {
        ...state,
        foodMenuDeleteLoading: false,
        foodMenuDeleteError: action.payload,
      };
    case FOOD_MENU_CATEGORY_LIST:
      return {
        ...state,
        foodMenuCategoryListLoading: true,
        foodMenuCategoryListError: null,
      };
    case FOOD_MENU_CATEGORY_LIST_SUCCESS:
      return {
        ...state,
        foodMenuCategoryList: action.payload,
        foodMenuCategoryListLoading: false,
      };
    case FOOD_MENU_CATEGORY_LIST_FAIL:
      return {
        ...state,
        foodMenuCategoryListLoading: false,
        foodMenuCategoryListError: action.payload,
      };
    case FOOD_MENU_CATEGORY_DATA:
      return {
        ...state,
        foodMenuCategoryDataLoading: true,
        foodMenuCategoryDataError: null,
      };
    case FOOD_MENU_CATEGORY_DATA_SUCCESS:
      return {
        ...state,
        foodMenuCategoryData: action.payload,
        foodMenuCategoryDataLoading: false,
      };
    case FOOD_MENU_CATEGORY_DATA_FAIL:
      return {
        ...state,
        foodMenuCategoryDataLoading: false,
        foodMenuCategoryDataError: action.payload,
      };
    case FOOD_MENU_CATEGORY_CREATE:
      return {
        ...state,
        foodMenuCategoryCreateLoading: true,
        foodMenuCategoryCreateError: null,
      };
    case FOOD_MENU_CATEGORY_CREATE_SUCCESS:
      return {
        ...state,
        foodMenuCategoryCreate: action.payload,
        foodMenuCategoryCreateLoading: false,
      };
    case FOOD_MENU_CATEGORY_CREATE_FAIL:
      return {
        ...state,
        foodMenuCategoryCreateLoading: false,
        foodMenuCategoryCreateError: action.payload,
      };
    case FOOD_MENU_CATEGORY_UPDATE:
      return {
        ...state,
        foodMenuCategoryUpdateLoading: true,
        foodMenuCategoryUpdateError: null,
      };
    case FOOD_MENU_CATEGORY_UPDATE_SUCCESS:
      return {
        ...state,
        foodMenuCategoryUpdate: action.payload,
        foodMenuCategoryUpdateLoading: false,
      };
    case FOOD_MENU_CATEGORY_UPDATE_FAIL:
      return {
        ...state,
        foodMenuCategoryUpdateLoading: false,
        foodMenuCategoryUpdateError: action.payload,
      };
    case FOOD_MENU_CATEGORY_DELETE:
      return {
        ...state,
        foodMenuCategoryDeleteLoading: true,
        foodMenuCategoryDeleteError: null,
      };
    case FOOD_MENU_CATEGORY_DELETE_SUCCESS:
      return {
        ...state,
        foodMenuCategoryDelete: action.payload,
        foodMenuCategoryDeleteLoading: false,
      };
    case FOOD_MENU_CATEGORY_DELETE_FAIL:
      return {
        ...state,
        foodMenuCategoryDeleteLoading: false,
        foodMenuCategoryDeleteError: action.payload,
      };
    case FOOD_MENU_ITEM_LIST:
      return {
        ...state,
        foodMenuItemListLoading: true,
        foodMenuItemListError: null,
      };
    case FOOD_MENU_ITEM_LIST_SUCCESS:
      return {
        ...state,
        foodMenuItemList: action.payload,
        foodMenuItemListLoading: false,
      };
    case FOOD_MENU_ITEM_LIST_FAIL:
      return {
        ...state,
        foodMenuItemListLoading: false,
        foodMenuItemListError: action.payload,
      };
    case FOOD_MENU_ITEM_DATA:
      return {
        ...state,
        foodMenuItemDataLoading: true,
        foodMenuItemDataError: null,
      };
    case FOOD_MENU_ITEM_DATA_SUCCESS:
      return {
        ...state,
        foodMenuItemData: action.payload,
        foodMenuItemDataLoading: false,
      };
    case FOOD_MENU_ITEM_DATA_FAIL:
      return {
        ...state,
        foodMenuItemDataLoading: false,
        foodMenuItemDataError: action.payload,
      };
    case FOOD_MENU_ITEM_CREATE:
      return {
        ...state,
        foodMenuItemCreateLoading: true,
        foodMenuItemCreateError: null,
      };
    case FOOD_MENU_ITEM_CREATE_SUCCESS:
      return {
        ...state,
        foodMenuItemCreate: action.payload,
        foodMenuItemCreateLoading: false,
      };
    case FOOD_MENU_ITEM_CREATE_FAIL:
      return {
        ...state,
        foodMenuItemCreateLoading: false,
        foodMenuItemCreateError: action.payload,
      };
    case FOOD_MENU_ITEM_UPDATE:
      return {
        ...state,
        foodMenuItemUpdateLoading: true,
        foodMenuItemUpdateError: null,
      };
    case FOOD_MENU_ITEM_UPDATE_SUCCESS:
      return {
        ...state,
        foodMenuItemUpdate: action.payload,
        foodMenuItemUpdateLoading: false,
      };
    case FOOD_MENU_ITEM_UPDATE_FAIL:
      return {
        ...state,
        foodMenuItemUpdateLoading: false,
        foodMenuItemUpdateError: action.payload,
      };
    case FOOD_MENU_ITEM_DELETE:
      return {
        ...state,
        foodMenuItemDeleteLoading: true,
        foodMenuItemDeleteError: null,
      };
    case FOOD_MENU_ITEM_DELETE_SUCCESS:
      return {
        ...state,
        foodMenuItemDelete: action.payload,
        foodMenuItemDeleteLoading: false,
      };
    case FOOD_MENU_ITEM_DELETE_FAIL:
      return {
        ...state,
        foodMenuItemDeleteLoading: false,
        foodMenuItemDeleteError: action.payload,
      };
    case FOOD_PREORDER_EVENT_STATUS_LIST:
      return {
        ...state,
        foodPreOrderEventStatusListLoading: true,
        foodPreOrderEventStatusListError: null,
      };
    case FOOD_PREORDER_EVENT_STATUS_LIST_SUCCESS:
      return {
        ...state,
        foodPreOrderEventStatusList: action.payload,
        foodPreOrderEventStatusListLoading: false,
      };
    case FOOD_PREORDER_EVENT_STATUS_LIST_FAIL:
      return {
        ...state,
        foodPreOrderEventStatusListLoading: false,
        foodPreOrderEventStatusListError: action.payload,
      };
    case FOOD_PREORDER_EVENT_STATUS_DATA:
      return {
        ...state,
        foodPreOrderEventStatusDataLoading: true,
        foodPreOrderEventStatusDataError: null,
      };
    case FOOD_PREORDER_EVENT_STATUS_DATA_SUCCESS:
      return {
        ...state,
        foodPreOrderEventStatusData: action.payload,
        foodPreOrderEventStatusDataLoading: false,
      };
    case FOOD_PREORDER_EVENT_STATUS_DATA_FAIL:
      return {
        ...state,
        foodPreOrderEventStatusDataLoading: false,
        foodPreOrderEventStatusDataError: action.payload,
      };
    case FOOD_PREORDER_EVENT_STATUS_CREATE:
      return {
        ...state,
        foodPreOrderEventStatusCreateLoading: true,
        foodPreOrderEventStatusCreateError: null,
      };
    case FOOD_PREORDER_EVENT_STATUS_CREATE_SUCCESS:
      return {
        ...state,
        foodPreOrderEventStatusCreate: action.payload,
        foodPreOrderEventStatusCreateLoading: false,
      };
    case FOOD_PREORDER_EVENT_STATUS_CREATE_FAIL:
      return {
        ...state,
        foodPreOrderEventStatusCreateLoading: false,
        foodPreOrderEventStatusCreateError: action.payload,
      };
    case FOOD_PREORDER_EVENT_STATUS_UPDATE:
      return {
        ...state,
        foodPreOrderEventStatusUpdateLoading: true,
        foodPreOrderEventStatusUpdateError: null,
      };
    case FOOD_PREORDER_EVENT_STATUS_UPDATE_SUCCESS:
      return {
        ...state,
        foodPreOrderEventStatusUpdate: action.payload,
        foodPreOrderEventStatusUpdateLoading: false,
      };
    case FOOD_PREORDER_EVENT_STATUS_UPDATE_FAIL:
      return {
        ...state,
        foodPreOrderEventStatusUpdateLoading: false,
        foodPreOrderEventStatusUpdateError: action.payload,
      };
    case FOOD_PREORDER_EVENT_STATUS_DELETE:
      return {
        ...state,
        foodPreOrderEventStatusDeleteLoading: true,
        foodPreOrderEventStatusDeleteError: null,
      };
    case FOOD_PREORDER_EVENT_STATUS_DELETE_SUCCESS:
      return {
        ...state,
        foodPreOrderEventStatusDelete: action.payload,
        foodPreOrderEventStatusDeleteLoading: false,
      };
    case FOOD_PREORDER_EVENT_STATUS_DELETE_FAIL:
      return {
        ...state,
        foodPreOrderEventStatusDeleteLoading: false,
        foodPreOrderEventStatusDeleteError: action.payload,
      };
    case FOOD_PREORDER_EVENT_TYPE_LIST:
      return {
        ...state,
        foodPreOrderEventTypeListLoading: true,
        foodPreOrderEventTypeListError: null,
      };
    case FOOD_PREORDER_EVENT_TYPE_LIST_SUCCESS:
      return {
        ...state,
        foodPreOrderEventTypeList: action.payload,
        foodPreOrderEventTypeListLoading: false,
      };
    case FOOD_PREORDER_EVENT_TYPE_LIST_FAIL:
      return {
        ...state,
        foodPreOrderEventTypeListLoading: false,
        foodPreOrderEventTypeListError: action.payload,
      };
    case FOOD_PREORDER_EVENT_TYPE_DATA:
      return {
        ...state,
        foodPreOrderEventTypeDataLoading: true,
        foodPreOrderEventTypeDataError: null,
      };
    case FOOD_PREORDER_EVENT_TYPE_DATA_SUCCESS:
      return {
        ...state,
        foodPreOrderEventTypeData: action.payload,
        foodPreOrderEventTypeDataLoading: false,
      };
    case FOOD_PREORDER_EVENT_TYPE_DATA_FAIL:
      return {
        ...state,
        foodPreOrderEventTypeDataLoading: false,
        foodPreOrderEventTypeDataError: action.payload,
      };
    case FOOD_PREORDER_EVENT_TYPE_CREATE:
      return {
        ...state,
        foodPreOrderEventTypeCreateLoading: true,
        foodPreOrderEventTypeCreateError: null,
      };
    case FOOD_PREORDER_EVENT_TYPE_CREATE_SUCCESS:
      return {
        ...state,
        foodPreOrderEventTypeCreate: action.payload,
        foodPreOrderEventTypeCreateLoading: false,
      };
    case FOOD_PREORDER_EVENT_TYPE_CREATE_FAIL:
      return {
        ...state,
        foodPreOrderEventTypeCreateLoading: false,
        foodPreOrderEventTypeCreateError: action.payload,
      };
    case FOOD_PREORDER_EVENT_TYPE_UPDATE:
      return {
        ...state,
        foodPreOrderEventTypeUpdateLoading: true,
        foodPreOrderEventTypeUpdateError: null,
      };
    case FOOD_PREORDER_EVENT_TYPE_UPDATE_SUCCESS:
      return {
        ...state,
        foodPreOrderEventTypeUpdate: action.payload,
        foodPreOrderEventTypeUpdateLoading: false,
      };
    case FOOD_PREORDER_EVENT_TYPE_UPDATE_FAIL:
      return {
        ...state,
        foodPreOrderEventTypeUpdateLoading: false,
        foodPreOrderEventTypeUpdateError: action.payload,
      };
    case FOOD_PREORDER_EVENT_TYPE_DELETE:
      return {
        ...state,
        foodPreOrderEventTypeDeleteLoading: true,
        foodPreOrderEventTypeDeleteError: null,
      };
    case FOOD_PREORDER_EVENT_TYPE_DELETE_SUCCESS:
      return {
        ...state,
        foodPreOrderEventTypeDelete: action.payload,
        foodPreOrderEventTypeDeleteLoading: false,
      };
    case FOOD_PREORDER_EVENT_TYPE_DELETE_FAIL:
      return {
        ...state,
        foodPreOrderEventTypeDeleteLoading: false,
        foodPreOrderEventTypeDeleteError: action.payload,
      };
    case FOOD_MENU_TYPE_LIST:
      return {
        ...state,
        foodMenuTypeListLoading: true,
        foodMenuTypeListError: null,
      };
    case FOOD_MENU_TYPE_LIST_SUCCESS:
      return {
        ...state,
        foodMenuTypeList: action.payload,
        foodMenuTypeListLoading: false,
      };
    case FOOD_MENU_TYPE_LIST_FAIL:
      return {
        ...state,
        foodMenuTypeListLoading: false,
        foodMenuTypeListError: action.payload,
      };
    case FOOD_MENU_TYPE_DATA:
      return {
        ...state,
        foodMenuTypeDataLoading: true,
        foodMenuTypeDataError: null,
      };
    case FOOD_MENU_TYPE_DATA_SUCCESS:
      return {
        ...state,
        foodMenuTypeData: action.payload,
        foodMenuTypeDataLoading: false,
      };
    case FOOD_MENU_TYPE_DATA_FAIL:
      return {
        ...state,
        foodMenuTypeDataLoading: false,
        foodMenuTypeDataError: action.payload,
      };
    case FOOD_MENU_TYPE_CREATE:
      return {
        ...state,
        foodMenuTypeCreateLoading: true,
        foodMenuTypeCreateError: null,
      };
    case FOOD_MENU_TYPE_CREATE_SUCCESS:
      return {
        ...state,
        foodMenuTypeCreate: action.payload,
        foodMenuTypeCreateLoading: false,
      };
    case FOOD_MENU_TYPE_CREATE_FAIL:
      return {
        ...state,
        foodMenuTypeCreateLoading: false,
        foodMenuTypeCreateError: action.payload,
      };
    case FOOD_MENU_TYPE_UPDATE:
      return {
        ...state,
        foodMenuTypeUpdateLoading: true,
        foodMenuTypeUpdateError: null,
      };
    case FOOD_MENU_TYPE_UPDATE_SUCCESS:
      return {
        ...state,
        foodMenuTypeUpdate: action.payload,
        foodMenuTypeUpdateLoading: false,
      };
    case FOOD_MENU_TYPE_UPDATE_FAIL:
      return {
        ...state,
        foodMenuTypeUpdateLoading: false,
        foodMenuTypeUpdateError: action.payload,
      };
    case FOOD_MENU_TYPE_DELETE:
      return {
        ...state,
        foodMenuTypeDeleteLoading: true,
        foodMenuTypeDeleteError: null,
      };
    case FOOD_MENU_TYPE_DELETE_SUCCESS:
      return {
        ...state,
        foodMenuTypeDelete: action.payload,
        foodMenuTypeDeleteLoading: false,
      };
    case FOOD_MENU_TYPE_DELETE_FAIL:
      return {
        ...state,
        foodMenuTypeDeleteLoading: false,
        foodMenuTypeDeleteError: action.payload,
      };
    case FOOD_PREORDER_SITE_LOCATION_LIST:
      return {
        ...state,
        foodPreOrderSiteLocationListLoading: true,
        foodPreOrderSiteLocationListError: null,
      };
    case FOOD_PREORDER_SITE_LOCATION_LIST_SUCCESS:
      return {
        ...state,
        foodPreOrderSiteLocationList: action.payload,
        foodPreOrderSiteLocationListLoading: false,
      };
    case FOOD_PREORDER_SITE_LOCATION_LIST_FAIL:
      return {
        ...state,
        foodPreOrderSiteLocationListLoading: false,
        foodPreOrderSiteLocationListError: action.payload,
      };
    case FOOD_PREORDER_SITE_LOCATION_DATA:
      return {
        ...state,
        foodPreOrderSiteLocationDataLoading: true,
        foodPreOrderSiteLocationDataError: null,
      };
    case FOOD_PREORDER_SITE_LOCATION_DATA_SUCCESS:
      return {
        ...state,
        foodPreOrderSiteLocationData: action.payload,
        foodPreOrderSiteLocationDataLoading: false,
      };
    case FOOD_PREORDER_SITE_LOCATION_DATA_FAIL:
      return {
        ...state,
        foodPreOrderSiteLocationDataLoading: false,
        foodPreOrderSiteLocationDataError: action.payload,
      };
    case FOOD_PREORDER_SITE_LOCATION_CREATE:
      return {
        ...state,
        foodPreOrderSiteLocationCreateLoading: true,
        foodPreOrderSiteLocationCreateError: null,
      };
    case FOOD_PREORDER_SITE_LOCATION_CREATE_SUCCESS:
      return {
        ...state,
        foodPreOrderSiteLocationCreate: action.payload,
        foodPreOrderSiteLocationCreateLoading: false,
      };
    case FOOD_PREORDER_SITE_LOCATION_CREATE_FAIL:
      return {
        ...state,
        foodPreOrderSiteLocationCreateLoading: false,
        foodPreOrderSiteLocationCreateError: action.payload,
      };
    case FOOD_PREORDER_SITE_LOCATION_UPDATE:
      return {
        ...state,
        foodPreOrderSiteLocationUpdateLoading: true,
        foodPreOrderSiteLocationUpdateError: null,
      };
    case FOOD_PREORDER_SITE_LOCATION_UPDATE_SUCCESS:
      return {
        ...state,
        foodPreOrderSiteLocationUpdate: action.payload,
        foodPreOrderSiteLocationUpdateLoading: false,
      };
    case FOOD_PREORDER_SITE_LOCATION_UPDATE_FAIL:
      return {
        ...state,
        foodPreOrderSiteLocationUpdateLoading: false,
        foodPreOrderSiteLocationUpdateError: action.payload,
      };
    case FOOD_PREORDER_SITE_LOCATION_DELETE:
      return {
        ...state,
        foodPreOrderSiteLocationDeleteLoading: true,
        foodPreOrderSiteLocationDeleteError: null,
      };
    case FOOD_PREORDER_SITE_LOCATION_DELETE_SUCCESS:
      return {
        ...state,
        foodPreOrderSiteLocationDelete: action.payload,
        foodPreOrderSiteLocationDeleteLoading: false,
      };
    case FOOD_PREORDER_SITE_LOCATION_DELETE_FAIL:
      return {
        ...state,
        foodPreOrderSiteLocationDeleteLoading: false,
        foodPreOrderSiteLocationDeleteError: action.payload,
      };
    case FOOD_PREORDER_EVENT_GUEST_TO_FOOD_MENU_ITEM_CREATE:
      return {
        ...state,
        foodPreOrderEventGuestToFoodMenuItemCreateLoading: true,
        foodPreOrderEventGuestToFoodMenuItemCreateError: null,
      };
    case FOOD_PREORDER_EVENT_GUEST_TO_FOOD_MENU_ITEM_CREATE_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGuestToFoodMenuItemCreate: action.payload,
        foodPreOrderEventGuestToFoodMenuItemCreateLoading: false,
      };
    case FOOD_PREORDER_EVENT_GUEST_TO_FOOD_MENU_ITEM_CREATE_FAIL:
      return {
        ...state,
        foodPreOrderEventGuestToFoodMenuItemCreateLoading: false,
        foodPreOrderEventGuestToFoodMenuItemCreateError: action.payload,
      };
    case FOOD_PREORDER_EVENT_GUEST_ACCEPT:
      return {
        ...state,
        foodPreOrderEventGuestAcceptLoading: true,
        foodPreOrderEventGuestAcceptError: null,
      };
    case FOOD_PREORDER_EVENT_GUEST_ACCEPT_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGuestAccept: action.payload,
        foodPreOrderEventGuestAcceptLoading: false,
      };
    case FOOD_PREORDER_EVENT_GUEST_ACCEPT_FAIL:
      return {
        ...state,
        foodPreOrderEventGuestAcceptLoading: false,
        foodPreOrderEventGuestAcceptError: action.payload,
      };
    case FOOD_PREORDER_EVENT_GUEST_DECLINE:
      return {
        ...state,
        foodPreOrderEventGuestDeclineLoading: true,
        foodPreOrderEventGuestDeclineError: null,
      };
    case FOOD_PREORDER_EVENT_GUEST_DECLINE_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGuestDecline: action.payload,
        foodPreOrderEventGuestDeclineLoading: false,
      };
    case FOOD_PREORDER_EVENT_GUEST_DECLINE_FAIL:
      return {
        ...state,
        foodPreOrderEventGuestDeclineLoading: false,
        foodPreOrderEventGuestDeclineError: action.payload,
      };
    case FOOD_MENU_SEARCH:
      return {
        ...state,
        foodMenuSearchLoading: true,
        foodMenuSearchError: null,
      };
    case FOOD_MENU_SEARCH_SUCCESS:
      return {
        ...state,
        foodMenuSearch: action.payload,
        foodMenuSearchLoading: false,
      };
    case FOOD_MENU_SEARCH_FAIL:
      return {
        ...state,
        foodMenuSearchLoading: false,
        foodMenuSearchError: action.payload,
      };

    case FOOD_PREORDER_EVENT_EMAIL_ORGANISER_EVENT_READY:
      return {
        ...state,
        foodPreOrderEventEmailOrganiserEventReadyLoading: true,
        foodPreOrderEventEmailOrganiserEventReadyError: null,
      };
    case FOOD_PREORDER_EVENT_EMAIL_ORGANISER_EVENT_READY_SUCCESS:
      return {
        ...state,
        foodPreOrderEventEmailOrganiserEventReady: action.payload,
        foodPreOrderEventEmailOrganiserEventReadyLoading: false,
      };
    case FOOD_PREORDER_EVENT_EMAIL_ORGANISER_EVENT_READY_FAIL:
      return {
        ...state,
        foodPreOrderEventEmailOrganiserEventReadyLoading: false,
        foodPreOrderEventEmailOrganiserEventReadyError: action.payload,
      };
    case FOOD_PREORDER_EVENT_GUEST_INVITE_RESEND:
      return {
        ...state,
        foodPreOrderEventGuestInviteResendLoading: true,
        foodPreOrderEventGuestInviteResendError: null,
      };
    case FOOD_PREORDER_EVENT_GUEST_INVITE_RESEND_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGuestInviteResend: action.payload,
        foodPreOrderEventGuestInviteResendLoading: false,
      };
    case FOOD_PREORDER_EVENT_GUEST_INVITE_RESEND_FAIL:
      return {
        ...state,
        foodPreOrderEventGuestInviteResendLoading: false,
        foodPreOrderEventGuestInviteResendError: action.payload,
      };
    case FOOD_PREORDER_EVENT_PDF_GUEST_LIST_CONFIRMED:
      return {
        ...state,
        foodPreOrderEventPdfGuestListConfirmedLoading: true,
        foodPreOrderEventPdfGuestListConfirmedError: null,
      };
    case FOOD_PREORDER_EVENT_PDF_GUEST_LIST_CONFIRMED_SUCCESS:
      return {
        ...state,
        foodPreOrderEventPdfGuestListConfirmed: action.payload,
        foodPreOrderEventPdfGuestListConfirmedLoading: false,
      };
    case FOOD_PREORDER_EVENT_PDF_GUEST_LIST_CONFIRMED_FAIL:
      return {
        ...state,
        foodPreOrderEventPdfGuestListConfirmedLoading: false,
        foodPreOrderEventPdfGuestListConfirmedError: action.payload,
      };
    case FOOD_PREORDER_EVENT_PDF_KITCHEN_MEAL_PLAN:
      return {
        ...state,
        foodPreOrderEventPdfKitchenMealPlanLoading: true,
        foodPreOrderEventPdfKitchenMealPlanError: null,
      };
    case FOOD_PREORDER_EVENT_PDF_KITCHEN_MEAL_PLAN_SUCCESS:
      return {
        ...state,
        foodPreOrderEventPdfKitchenMealPlan: action.payload,
        foodPreOrderEventPdfKitchenMealPlanLoading: false,
      };
    case FOOD_PREORDER_EVENT_PDF_KITCHEN_MEAL_PLAN_FAIL:
      return {
        ...state,
        foodPreOrderEventPdfKitchenMealPlanLoading: false,
        foodPreOrderEventPdfKitchenMealPlanError: action.payload,
      };
    case FOOD_PREORDER_EVENT_PDF_TABLE_TENT_CARDS:
      return {
        ...state,
        foodPreOrderEventPdfTableTentCardsLoading: true,
        foodPreOrderEventPdfTableTentCardsError: null,
      };
    case FOOD_PREORDER_EVENT_PDF_TABLE_TENT_CARDS_SUCCESS:
      return {
        ...state,
        foodPreOrderEventPdfTableTentCards: action.payload,
        foodPreOrderEventPdfTableTentCardsLoading: false,
      };
    case FOOD_PREORDER_EVENT_PDF_TABLE_TENT_CARDS_FAIL:
      return {
        ...state,
        foodPreOrderEventPdfTableTentCardsLoading: false,
        foodPreOrderEventPdfTableTentCardsError: action.payload,
      };
    case FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST:
      return {
        ...state,
        foodPreOrderEventRecentActivityListLoading: true,
        foodPreOrderEventRecentActivityListError: null,
      };
    case FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_SUCCESS:
      return {
        ...state,
        foodPreOrderEventRecentActivityList: action.payload,
        foodPreOrderEventRecentActivityListLoading: false,
      };
    case FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_FAIL:
      return {
        ...state,
        foodPreOrderEventRecentActivityListLoading: false,
        foodPreOrderEventRecentActivityListError: action.payload,
      };
    case FOOD_PREORDER_EVENT_COMMUNICATION_LIST:
      return {
        ...state,
        foodPreOrderEventCommunicationListLoading: true,
        foodPreOrderEventCommunicationListError: null,
      };
    case FOOD_PREORDER_EVENT_COMMUNICATION_LIST_SUCCESS:
      return {
        ...state,
        foodPreOrderEventCommunicationList: action.payload,
        foodPreOrderEventCommunicationListLoading: false,
      };
    case FOOD_PREORDER_EVENT_COMMUNICATION_LIST_FAIL:
      return {
        ...state,
        foodPreOrderEventCommunicationListLoading: false,
        foodPreOrderEventCommunicationListError: action.payload,
      };
    case FOOD_PREORDER_EVENT_ATTACHMENT_SEARCH:
      return {
        ...state,
        foodPreOrderEventAttachmentListLoading: true,
        foodPreOrderEventAttachmentListError: null,
      };
    case FOOD_PREORDER_EVENT_ATTACHMENT_SEARCH_SUCCESS:
      return {
        ...state,
        foodPreOrderEventAttachmentList: action.payload,
        foodPreOrderEventAttachmentListLoading: false,
      };
    case FOOD_PREORDER_EVENT_ATTACHMENT_SEARCH_FAIL:
      return {
        ...state,
        foodPreOrderEventAttachmentList: [],
        foodPreOrderEventAttachmentListLoading: false,
        foodPreOrderEventAttachmentListError: action.payload,
      };
    case FOOD_PREORDER_EVENT_ATTACHMENT_DELETE:
      return {
        ...state,
        foodPreOrderEventAttachmentDeleteLoading: true,
        foodPreOrderEventAttachmentDeleteError: null,
      };
    case FOOD_PREORDER_EVENT_ATTACHMENT_DELETE_SUCCESS:
      return {
        ...state,
        foodPreOrderEventAttachmentDelete: action.payload,
        foodPreOrderEventAttachmentDeleteLoading: false,
      };
    case FOOD_PREORDER_EVENT_ATTACHMENT_DELETE_FAIL:
      return {
        ...state,
        foodPreOrderEventAttachmentDelete: [],
        foodPreOrderEventAttachmentDeleteLoading: false,
        foodPreOrderEventAttachmentDeleteError: action.payload,
      };
    case FOOD_PREORDER_EVENT_SMS_ORGANISER_EVENT_READY:
      return {
        ...state,
        foodPreOrderEventSmsOrganiserEventReadyLoading: true,
        foodPreOrderEventSmsOrganiserEventReadyError: null,
      };
    case FOOD_PREORDER_EVENT_SMS_ORGANISER_EVENT_READY_SUCCESS:
      return {
        ...state,
        foodPreOrderEventSmsOrganiserEventReady: action.payload,
        foodPreOrderEventSmsOrganiserEventReadyLoading: false,
      };
    case FOOD_PREORDER_EVENT_SMS_ORGANISER_EVENT_READY_FAIL:
      return {
        ...state,
        foodPreOrderEventSmsOrganiserEventReadyLoading: false,
        foodPreOrderEventSmsOrganiserEventReadyError: action.payload,
      };
    case FOOD_MENU_ITEM_SEARCH:
      return {
        ...state,
        foodMenuItemSearchLoading: true,
        foodMenuItemSearchError: null,
      };
    case FOOD_MENU_ITEM_SEARCH_SUCCESS:
      return {
        ...state,
        foodMenuItemSearch: action.payload,
        foodMenuItemSearchLoading: false,
      };
    case FOOD_MENU_ITEM_SEARCH_FAIL:
      return {
        ...state,
        foodMenuItemSearchLoading: false,
        foodMenuItemSearchError: action.payload,
      };
    case FOOD_PREORDER_EVENT_PDF_FRONT_OF_HOUSE_MEAL_PLAN:
      return {
        ...state,
        foodPreOrderEventPdfFrontOfHouseMealPlanLoading: true,
        foodPreOrderEventPdfFrontOfHouseMealPlanError: null,
      };
    case FOOD_PREORDER_EVENT_PDF_FRONT_OF_HOUSE_MEAL_PLAN_SUCCESS:
      return {
        ...state,
        foodPreOrderEventPdfFrontOfHouseMealPlan: action.payload,
        foodPreOrderEventPdfFrontOfHouseMealPlanLoading: false,
      };
    case FOOD_PREORDER_EVENT_PDF_FRONT_OF_HOUSE_MEAL_PLAN_FAIL:
      return {
        ...state,
        foodPreOrderEventPdfFrontOfHouseMealPlanLoading: false,
        foodPreOrderEventPdfFrontOfHouseMealPlanError: action.payload,
      };
    case FOOD_PREORDER_EVENT_GUEST_PAYMENT_LIST:
      return {
        ...state,
        foodPreOrderEventGuestPaymentListLoading: true,
        foodPreOrderEventGuestPaymentListError: null,
      };
    case FOOD_PREORDER_EVENT_GUEST_PAYMENT_LIST_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGuestPaymentList: action.payload,
        foodPreOrderEventGuestPaymentListLoading: false,
      };
    case FOOD_PREORDER_EVENT_GUEST_PAYMENT_LIST_FAIL:
      return {
        ...state,
        foodPreOrderEventGuestPaymentListLoading: false,
        foodPreOrderEventGuestPaymentListError: action.payload,
      };
    case FOOD_PREORDER_EVENT_GUEST_PAYMENT_SEARCH:
      return {
        ...state,
        foodPreOrderEventGuestPaymentSearchLoading: true,
        foodPreOrderEventGuestPaymentSearchError: null,
      };
    case FOOD_PREORDER_EVENT_GUEST_PAYMENT_SEARCH_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGuestPaymentSearch: action.payload,
        foodPreOrderEventGuestPaymentSearchLoading: false,
      };
    case FOOD_PREORDER_EVENT_GUEST_PAYMENT_SEARCH_FAIL:
      return {
        ...state,
        foodPreOrderEventGuestPaymentSearchLoading: false,
        foodPreOrderEventGuestPaymentSearchError: action.payload,
      };
    case FOOD_PREORDER_EVENT_GROUP_LIST:
      return {
        ...state,
        foodPreOrderEventGroupListLoading: true,
        foodPreOrderEventGroupListError: null,
      };
    case FOOD_PREORDER_EVENT_GROUP_LIST_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGroupList: action.payload,
        foodPreOrderEventGroupListLoading: false,
      };
    case FOOD_PREORDER_EVENT_GROUP_LIST_FAIL:
      return {
        ...state,
        foodPreOrderEventGroupListLoading: false,
        foodPreOrderEventGroupListError: action.payload,
      };
    case FOOD_PREORDER_EVENT_GROUP_DATA:
      return {
        ...state,
        foodPreOrderEventGroupDataLoading: true,
        foodPreOrderEventGroupDataError: null,
      };
    case FOOD_PREORDER_EVENT_GROUP_DATA_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGroupData: action.payload,
        foodPreOrderEventGroupDataLoading: false,
      };
    case FOOD_PREORDER_EVENT_GROUP_DATA_FAIL:
      return {
        ...state,
        foodPreOrderEventGroupDataLoading: false,
        foodPreOrderEventGroupDataError: action.payload,
      };
    case FOOD_PREORDER_EVENT_GROUP_CREATE:
      return {
        ...state,
        foodPreOrderEventGroupCreateLoading: true,
        foodPreOrderEventGroupCreateError: null,
      };
    case FOOD_PREORDER_EVENT_GROUP_CREATE_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGroupCreate: action.payload,
        foodPreOrderEventGroupCreateLoading: false,
      };
    case FOOD_PREORDER_EVENT_GROUP_CREATE_FAIL:
      return {
        ...state,
        foodPreOrderEventGroupCreateLoading: false,
        foodPreOrderEventGroupCreateError: action.payload,
      };
    case FOOD_PREORDER_EVENT_GROUP_UPDATE:
      return {
        ...state,
        foodPreOrderEventGroupUpdateLoading: true,
        foodPreOrderEventGroupUpdateError: null,
      };
    case FOOD_PREORDER_EVENT_GROUP_UPDATE_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGroupUpdate: action.payload,
        foodPreOrderEventGroupUpdateLoading: false,
      };
    case FOOD_PREORDER_EVENT_GROUP_UPDATE_FAIL:
      return {
        ...state,
        foodPreOrderEventGroupUpdateLoading: false,
        foodPreOrderEventGroupUpdateError: action.payload,
      };
    case FOOD_PREORDER_EVENT_GROUP_DELETE:
      return {
        ...state,
        foodPreOrderEventGroupDeleteLoading: true,
        foodPreOrderEventGroupDeleteError: null,
      };
    case FOOD_PREORDER_EVENT_GROUP_DELETE_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGroupDelete: action.payload,
        foodPreOrderEventGroupDeleteLoading: false,
      };
    case FOOD_PREORDER_EVENT_GROUP_DELETE_FAIL:
      return {
        ...state,
        foodPreOrderEventGroupDeleteLoading: false,
        foodPreOrderEventGroupDeleteError: action.payload,
      };
    case FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_DATA:
      return {
        ...state,
        foodPreOrderEventRecentActivityListDataLoading: true,
        foodPreOrderEventRecentActivityListDataError: null,
      };
    case FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_DATA_SUCCESS:
      return {
        ...state,
        foodPreOrderEventRecentActivityListData: action.payload,
        foodPreOrderEventRecentActivityListDataLoading: false,
      };
    case FOOD_PREORDER_EVENT_RECENT_ACTIVITY_LIST_DATA_FAIL:
      return {
        ...state,
        foodPreOrderEventRecentActivityListDataLoading: false,
        foodPreOrderEventRecentActivityListDataError: action.payload,
      };
    case FOOD_PREORDER_EVENT_GROUP_PDF_KITCHEN_MEAL_PLAN:
      return {
        ...state,
        foodPreOrderEventGroupPdfKitchenMealPlanLoading: true,
        foodPreOrderEventGroupPdfKitchenMealPlanError: null,
      };
    case FOOD_PREORDER_EVENT_GROUP_PDF_KITCHEN_MEAL_PLAN_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGroupPdfKitchenMealPlan: action.payload,
        foodPreOrderEventGroupPdfKitchenMealPlanLoading: false,
      };
    case FOOD_PREORDER_EVENT_GROUP_PDF_KITCHEN_MEAL_PLAN_FAIL:
      return {
        ...state,
        foodPreOrderEventGroupPdfKitchenMealPlanLoading: false,
        foodPreOrderEventGroupPdfKitchenMealPlanError: action.payload,
      };
    case FOOD_PREORDER_EVENT_GROUP_PDF_FRONT_OF_HOUSE_MEAL_PLAN:
      return {
        ...state,
        foodPreOrderEventGroupPdfFrontOfHouseMealPlanLoading: true,
        foodPreOrderEventGroupPdfFrontOfHouseMealPlanError: null,
      };
    case FOOD_PREORDER_EVENT_GROUP_PDF_FRONT_OF_HOUSE_MEAL_PLAN_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGroupPdfFrontOfHouseMealPlan: action.payload,
        foodPreOrderEventGroupPdfFrontOfHouseMealPlanLoading: false,
      };
    case FOOD_PREORDER_EVENT_GROUP_PDF_FRONT_OF_HOUSE_MEAL_PLAN_FAIL:
      return {
        ...state,
        foodPreOrderEventGroupPdfFrontOfHouseMealPlanLoading: false,
        foodPreOrderEventGroupPdfFrontOfHouseMealPlanError: action.payload,
      };
    case FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_TENT_CARDS:
      return {
        ...state,
        foodPreOrderEventGroupPdfTableTentCardsLoading: true,
        foodPreOrderEventGroupPdfTableTentCardsError: null,
      };
    case FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_TENT_CARDS_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGroupPdfTableTentCards: action.payload,
        foodPreOrderEventGroupPdfTableTentCardsLoading: false,
      };
    case FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_TENT_CARDS_FAIL:
      return {
        ...state,
        foodPreOrderEventGroupPdfTableTentCardsLoading: false,
        foodPreOrderEventGroupPdfTableTentCardsError: action.payload,
      };
    case FOOD_PREORDER_EVENT_GROUP_PDF_GUEST_LIST_CONFIRMED:
      return {
        ...state,
        foodPreOrderEventGroupPdfGuestListConfirmedLoading: true,
        foodPreOrderEventGroupPdfGuestListConfirmedError: null,
      };
    case FOOD_PREORDER_EVENT_GROUP_PDF_GUEST_LIST_CONFIRMED_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGroupPdfGuestListConfirmed: action.payload,
        foodPreOrderEventGroupPdfGuestListConfirmedLoading: false,
      };
    case FOOD_PREORDER_EVENT_GROUP_PDF_GUEST_LIST_CONFIRMED_FAIL:
      return {
        ...state,
        foodPreOrderEventGroupPdfGuestListConfirmedLoading: false,
        foodPreOrderEventGroupPdfGuestListConfirmedError: action.payload,
      };
    case FOOD_PREORDER_EVENT_GROUP_CSV_FRONT_OF_HOUSE_MEAL_PLAN:
      return {
        ...state,
        foodPreOrderEventGroupCsvFrontOfHouseMealPlanLoading: true,
        foodPreOrderEventGroupCsvFrontOfHouseMealPlanError: null,
      };
    case FOOD_PREORDER_EVENT_GROUP_CSV_FRONT_OF_HOUSE_MEAL_PLAN_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGroupCsvFrontOfHouseMealPlan: action.payload,
        foodPreOrderEventGroupCsvFrontOfHouseMealPlanLoading: false,
      };
    case FOOD_PREORDER_EVENT_GROUP_CSV_FRONT_OF_HOUSE_MEAL_PLAN_FAIL:
      return {
        ...state,
        foodPreOrderEventGroupCsvFrontOfHouseMealPlanLoading: false,
        foodPreOrderEventGroupCsvFrontOfHouseMealPlanError: action.payload,
      };
    case FOOD_PREORDER_EVENT_GROUP_CSV_KITCHEN_MEAL_PLAN:
      return {
        ...state,
        foodPreOrderEventGroupCsvKitchenMealPlanLoading: true,
        foodPreOrderEventGroupCsvKitchenMealPlanError: null,
      };
    case FOOD_PREORDER_EVENT_GROUP_CSV_KITCHEN_MEAL_PLAN_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGroupCsvKitchenMealPlan: action.payload,
        foodPreOrderEventGroupCsvKitchenMealPlanLoading: false,
      };
    case FOOD_PREORDER_EVENT_GROUP_CSV_KITCHEN_MEAL_PLAN_FAIL:
      return {
        ...state,
        foodPreOrderEventGroupCsvKitchenMealPlanLoading: false,
        foodPreOrderEventGroupCsvKitchenMealPlanError: action.payload,
      };
    case FOOD_PREORDER_EVENT_GROUP_CSV_GUEST_LIST_CONFIRMED:
      return {
        ...state,
        foodPreOrderEventGroupCsvGuestListConfirmedLoading: true,
        foodPreOrderEventGroupCsvGuestListConfirmedError: null,
      };
    case FOOD_PREORDER_EVENT_GROUP_CSV_GUEST_LIST_CONFIRMED_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGroupCsvGuestListConfirmed: action.payload,
        foodPreOrderEventGroupCsvGuestListConfirmedLoading: false,
      };
    case FOOD_PREORDER_EVENT_GROUP_CSV_GUEST_LIST_CONFIRMED_FAIL:
      return {
        ...state,
        foodPreOrderEventGroupCsvGuestListConfirmedLoading: false,
        foodPreOrderEventGroupCsvGuestListConfirmedError: action.payload,
      };
    case FOOD_PREORDER_EVENT_GROUP_CSV_TABLE_PLAN_LIST:
      return {
        ...state,
        foodPreOrderEventGroupCsvTablePlanListLoading: true,
        foodPreOrderEventGroupCsvTablePlanListError: null,
      };
    case FOOD_PREORDER_EVENT_GROUP_CSV_TABLE_PLAN_LIST_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGroupCsvTablePlanList: action.payload,
        foodPreOrderEventGroupCsvTablePlanListLoading: false,
      };
    case FOOD_PREORDER_EVENT_GROUP_CSV_TABLE_PLAN_LIST_FAIL:
      return {
        ...state,
        foodPreOrderEventGroupCsvTablePlanListLoading: false,
        foodPreOrderEventGroupCsvTablePlanListError: action.payload,
      };
    case FOOD_PREORDER_EVENT_CSV_KITCHEN_MEAL_PLAN:
      return {
        ...state,
        foodPreOrderEventCsvKitchenMealPlanLoading: true,
        foodPreOrderEventCsvKitchenMealPlanError: null,
      };
    case FOOD_PREORDER_EVENT_CSV_KITCHEN_MEAL_PLAN_SUCCESS:
      return {
        ...state,
        foodPreOrderEventCsvKitchenMealPlan: action.payload,
        foodPreOrderEventCsvKitchenMealPlanLoading: false,
      };
    case FOOD_PREORDER_EVENT_CSV_KITCHEN_MEAL_PLAN_FAIL:
      return {
        ...state,
        foodPreOrderEventCsvKitchenMealPlanLoading: false,
        foodPreOrderEventCsvKitchenMealPlanError: action.payload,
      };
    case FOOD_PREORDER_EVENT_CSV_FRONT_OF_HOUSE_MEAL_PLAN:
      return {
        ...state,
        foodPreOrderEventCsvFrontOfHouseMealPlanLoading: true,
        foodPreOrderEventCsvFrontOfHouseMealPlanError: null,
      };
    case FOOD_PREORDER_EVENT_CSV_FRONT_OF_HOUSE_MEAL_PLAN_SUCCESS:
      return {
        ...state,
        foodPreOrderEventCsvFrontOfHouseMealPlan: action.payload,
        foodPreOrderEventCsvFrontOfHouseMealPlanLoading: false,
      };
    case FOOD_PREORDER_EVENT_CSV_FRONT_OF_HOUSE_MEAL_PLAN_FAIL:
      return {
        ...state,
        foodPreOrderEventCsvFrontOfHouseMealPlanLoading: false,
        foodPreOrderEventCsvFrontOfHouseMealPlanError: action.payload,
      };
    case FOOD_PREORDER_EVENT_CSV_GUEST_LIST_CONFIRMED:
      return {
        ...state,
        foodPreOrderEventCsvGuestListConfirmedLoading: true,
        foodPreOrderEventCsvGuestListConfirmedError: null,
      };
    case FOOD_PREORDER_EVENT_CSV_GUEST_LIST_CONFIRMED_SUCCESS:
      return {
        ...state,
        foodPreOrderEventCsvGuestListConfirmed: action.payload,
        foodPreOrderEventCsvGuestListConfirmedLoading: false,
      };
    case FOOD_PREORDER_EVENT_CSV_GUEST_LIST_CONFIRMED_FAIL:
      return {
        ...state,
        foodPreOrderEventCsvGuestListConfirmedLoading: false,
        foodPreOrderEventCsvGuestListConfirmedError: action.payload,
      };
    case FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_PLAN_LIST:
      return {
        ...state,
        foodPreOrderEventGroupPdfTablePlanListLoading: true,
        foodPreOrderEventGroupPdfTablePlanListError: null,
      };
    case FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_PLAN_LIST_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGroupPdfTablePlanList: action.payload,
        foodPreOrderEventGroupPdfTablePlanListLoading: false,
      };
    case FOOD_PREORDER_EVENT_GROUP_PDF_TABLE_PLAN_LIST_FAIL:
      return {
        ...state,
        foodPreOrderEventGroupPdfTablePlanListLoading: false,
        foodPreOrderEventGroupPdfTablePlanListError: action.payload,
      };
    case FOOD_PREORDER_EVENT_GROUP_CSV_DRINK_LIST_BY_TABLE:
      return {
        ...state,
        foodPreOrderEventGroupCsvDrinkListByTableLoading: true,
        foodPreOrderEventGroupCsvDrinkListByTableError: null,
      };
    case FOOD_PREORDER_EVENT_GROUP_CSV_DRINK_LIST_BY_TABLE_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGroupCsvDrinkListByTable: action.payload,
        foodPreOrderEventGroupCsvDrinkListByTableLoading: false,
      };
    case FOOD_PREORDER_EVENT_GROUP_CSV_DRINK_LIST_BY_TABLE_FAIL:
      return {
        ...state,
        foodPreOrderEventGroupCsvDrinkListByTableLoading: false,
        foodPreOrderEventGroupCsvDrinkListByTableError: action.payload,
      };
    case FOOD_PREORDER_EVENT_GROUP_PDF_DRINK_LIST_BY_TABLE:
      return {
        ...state,
        foodPreOrderEventGroupPdfDrinkListByTableLoading: true,
        foodPreOrderEventGroupPdfDrinkListByTableError: null,
      };
    case FOOD_PREORDER_EVENT_GROUP_PDF_DRINK_LIST_BY_TABLE_SUCCESS:
      return {
        ...state,
        foodPreOrderEventGroupPdfDrinkListByTable: action.payload,
        foodPreOrderEventGroupPdfDrinkListByTableLoading: false,
      };
    case FOOD_PREORDER_EVENT_GROUP_PDF_DRINK_LIST_BY_TABLE_FAIL:
      return {
        ...state,
        foodPreOrderEventGroupPdfDrinkListByTableLoading: false,
        foodPreOrderEventGroupPdfDrinkListByTableError: action.payload,
      };
    case FOOD_PREORDER_SITE_LOCATION_SEARCH:
      return {
        ...state,
        foodPreOrderSiteLocationSearchLoading: true,
        foodPreOrderSiteLocationSearchError: null,
      };
    case FOOD_PREORDER_SITE_LOCATION_SEARCH_SUCCESS:
      return {
        ...state,
        foodPreOrderSiteLocationSearch: action.payload,
        foodPreOrderSiteLocationSearchLoading: false,
      };
    case FOOD_PREORDER_SITE_LOCATION_SEARCH_FAIL:
      return {
        ...state,
        foodPreOrderSiteLocationSearchLoading: false,
        foodPreOrderSiteLocationSearchError: action.payload,
      };
    //FOOD_MENU_CLONE
    case FOOD_MENU_CLONE:
      return {
        ...state,
        foodMenuCloneLoading: true,
        foodMenuCloneError: null,
      };
    case FOOD_MENU_CLONE_SUCCESS:
      return {
        ...state,
        foodMenuClone: action.payload,
        foodMenuCloneLoading: false,
      };
    case FOOD_MENU_CLONE_FAIL:
      return {
        ...state,
        foodMenuCloneLoading: false,
        foodMenuCloneError: action.payload,
      };
    default:
      return state;
  }
};

export default FoodPreOrderEventReducer;
